import { LOCAL_STORAGE_KEYS } from "@/constants/common-constants";

// A CLEAR session the guest was sent to. CLEAR only redirects back when its flow ends, so if its
// page fails the guest returns to Kashu on their own and the session is still awaiting_user_input:
// kept so the app can check the session on its next load (ClearSessionErrorCheck).
const STORAGE_KEY = LOCAL_STORAGE_KEYS.CLEARME_SESSION_TOKEN;

export type PendingClearSession = {
	guestId: number;
	startedAt: string;
};

export function savePendingClearSession(guestId: number) {
	try {
		const pending: PendingClearSession = {
			guestId,
			startedAt: new Date().toISOString(),
		};
		localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
	} catch {
		// Storage unavailable: the guest just won't see the CLEAR error message.
	}
}

export function loadPendingClearSession(): PendingClearSession | null {
	try {
		const saved = localStorage.getItem(STORAGE_KEY);
		return saved ? (JSON.parse(saved) as PendingClearSession) : null;
	} catch {
		return null;
	}
}

export function clearPendingClearSession() {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// Nothing to clear.
	}
}

export const CLEAR_APPLICATION_ERROR_MESSAGE =
	"Clear application error, see the Clear browser console for more information.";
